import moment from "moment"
import { ReArrange } from "./formUtilsNew"

// Converting Date 
export function formatDate(val, key) {

    if (!val) return ''
    const date = new Date(val)
    if (isNaN(date.getTime())) return val // Return original if invalid date

    if (key == 'tanggal') {
        return moment(val).format('LL')
    } else if (key == 'jam') {
        return moment(val).format('HH:mm')
    }

    // const YYYY = date.getFullYear()
    // const MM   = String(date.getMonth() + 1).padStart(2, '0')
    // const DD   = String(date.getDate()).padStart(2, '0')
    // const hh   = String(date.getHours()).padStart(2, '0')
    // const mm   = String(date.getMinutes()).padStart(2, '0')
    // const ss   = String(date.getSeconds()).padStart(2, '0')

    // return `${YYYY}-${MM}-${DD} ${hh}:${mm}:${ss}`
}

// Check if data value like DATE
function isDateField(key, sampleValue) {
    const lowerKey = key.toLowerCase()
    // Check common naming like containing date/time fields
    if (lowerKey.includes('date') || lowerKey.includes('time') || lowerKey.includes('_at') || lowerKey.includes('trx')) {
        return true
    }

    // Check string format (e.g. "2026-08-13T14:30:00.000Z")
    if (typeof sampleValue === 'string') {
        return !isNaN(Date.parse(sampleValue)) && sampleValue.length >= 10 && (sampleValue.includes('-') || sampleValue.includes(':'))
    }
    return false
}

/**
* Converts snake_case or camelCase keys to readable Header Names
* eg : date_trz convert Date Trx
*/
function formatHeaderName(key) {
    return key
        .replace(/_/g, ' ')
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .replace(/\b\w/g, char => char.toUpperCase())
}
  
/**
 * Generates AG Grid Column Definitions dynamically based on API JSON records
 * @param {Array} data - Array of row objects from API
 * @param {Object} customHeaders - Optional map to override header names { m_code: 'Member Code' }
 */

export function GridGenerator(data, customHeaders = {}, hideFields = [], customFormatValue = {}, removeCompletely = true) {
    if (!Array.isArray(data) || data.length === 0) return []
    
    const isHideSymbol = hideFields[0].includes('-')
    
    if (!isHideSymbol) {
        data = ReArrange(hideFields, data) 
    }
    
    const sampleRow = data[0]
    const columns = []

    moment.locale('id')

    let hasDurationColumn = false
  
    Object.keys(sampleRow).forEach((key) => {
        if (key === 'amount_day' || key === 'amount_hour') {
            if (!hasDurationColumn) {
                hasDurationColumn = true
                
                columns.push({
                    headerName  : 'Durasi',
                    field       : 'duration',
                    sortable    : true,
                    filter      : true,
                    resizable   : true,
                    valueGetter : (params) => {
                        const day = Number(params.data?.amount_day) || 0
                        const hour = Number(params.data?.amount_hour) || 0

                        if (day > 0) {
                            return `${day} Hari`
                        } 
                        
                        return `${hour} Jam`
                    }
                })
            }
            return
        }
        
        // Check if key is in the hideFields list
        const isHidden = hideFields.includes(key)

        // Option A: Exclude column completely from columnDefs
        if (isHidden && removeCompletely && isHideSymbol) {
            return // skip this field
        }

        const sampleValue = sampleRow[key]
        const headerName = customHeaders[key] || formatHeaderName(key)
  
        const colDef = {
              headerName
            , field    : key
            , sortable : true
            , filter   : true
            , resizable: true
        }
  
        // Auto-detect and format Date fields

        if (isDateField(key, sampleValue)) {
            colDef.valueFormatter = (params) => formatDate(params.value, customFormatValue[key])
            colDef.width = 180
        } else if (key.toLowerCase() === 'id') {
            colDef.width = 80
            colDef.flex = 0
        } else if (customFormatValue[key]) {
            colDef.valueFormatter = (params) => formatDate(params.value, customFormatValue[key])
        }
  
        columns.push(colDef)
    })
  
    return columns
  }